// extracted by mini-css-extract-plugin
export default {"Argument":"Arg_Argument__XOxNz","Title":"Arg_Title__rPWQA","Body":"Arg_Body__kXZJC","Image":"Arg_Image__4zBNF"};